export default __webpack_public_path__ + "static/media/bees4.b21539a1.png";